import React, { forwardRef } from 'react';
import { Typography } from '@mui/material'; //change to PRIME Typography once they support Print font size
import { isEmpty, find, isString } from 'lodash';
import PropTypes from 'prop-types';
import MarkedValue from './components/MarkedValue/MarkedValue';

const formatFieldId = ({ fieldId }) =>
  isString(fieldId) ? fieldId.toLowerCase().split(' ').join('-') : fieldId;

const TypographyMarked = forwardRef(
  ({ isPrint, value, fieldId, searchContextValues = {}, dataTestId = '', ...rest }, ref) => {
    //Ignore Components
    if (typeof value === 'object') {
      return value;
    }

    const { getActiveResultId, searchResults, setSearchResults, vehicleDetailsSearchString } =
      searchContextValues || {};

    const formattedFieldId = formatFieldId({ fieldId });

    const handleSearchResults = (fieldIdWithIndex) => {
      const isAlreadyInSearchResults = !!find(searchResults, {
        fieldId: fieldIdWithIndex,
      });

      if (!isAlreadyInSearchResults) {
        setSearchResults((prev) => {
          if (prev.some((r) => r.fieldId === fieldIdWithIndex)) return prev;

          return [
            ...prev,
            {
              fieldId: fieldIdWithIndex,
              fieldTarget: formattedFieldId,
              value,
            },
          ];
        });
      }
    };

    return (
      <Typography
        {...rest}
        id={formattedFieldId}
        ref={ref}
        data-testid={dataTestId ? dataTestId : null}
      >
        {isPrint || isEmpty(vehicleDetailsSearchString) ? (
          value
        ) : (
          <MarkedValue
            value={value}
            handleSearchResults={handleSearchResults}
            vehicleDetailsSearchString={vehicleDetailsSearchString}
            formattedFieldId={formattedFieldId}
            getActiveResultId={getActiveResultId}
          />
        )}
      </Typography>
    );
  },
);

TypographyMarked.displayName = 'TypographyMarked';
TypographyMarked.propTypes = {
  dataTestId: PropTypes.string,
  isPrint: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  fieldId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  searchContextValues: PropTypes.object,
};

export default TypographyMarked;
